/**
 * El marco de la cámara: un rectángulo con la proporción de la tarjeta (ID-1,
 * 85,6 × 54 mm) que ayuda a embocar el DNI. Ocupa el 85 % del lado que lo limita
 * —el ancho en un video apaisado, el alto si no entra— y va centrado.
 *
 * La foto se saca entera; el marco viaja a la lectura como PISTA de dónde está
 * la tarjeta (fracciones de la foto), para buscar su contorno ahí o recortar
 * cuando no hay ancla. Nunca es garantía de tapado: dónde puso la persona el
 * documento no es una medición.
 */
import { Rectangulo } from "./types";
import { TARJETA_ID1 } from "./tuning";

const OCUPACION = 0.85;

export function marcoDeLaTarjeta(ancho: number, alto: number): Rectangulo {
  let w = ancho * OCUPACION;
  let h = w / TARJETA_ID1.relacionDeLados;
  if (h > alto * OCUPACION) {
    h = alto * OCUPACION;
    w = h * TARJETA_ID1.relacionDeLados;
  }
  return { x: (ancho - w) / 2, y: (alto - h) / 2, w, h };
}

/** La pista (fracciones de la foto) en la foto girada en el sentido de las agujas `grados`. */
export function pistaGirada(p: Rectangulo, grados: number): Rectangulo {
  const g = ((grados % 360) + 360) % 360;
  if (g === 90) return { x: 1 - (p.y + p.h), y: p.x, w: p.h, h: p.w };
  if (g === 180) return { x: 1 - (p.x + p.w), y: 1 - (p.y + p.h), w: p.w, h: p.h };
  if (g === 270) return { x: p.y, y: 1 - (p.x + p.w), w: p.h, h: p.w };
  return p;
}
